import { useContext } from "react";

import { SalesPageV3Context } from "../context";

export const useCustomGoals = () => {
  const context = useContext(SalesPageV3Context);

  if (!context) {
    throw new Error("useCustomGoals can only be used inside SalesV3Provider");
  }

  return {
    customGoals: context.customGoals,
    isCustomGoalsDataLoading: context.isCustomGoalsDataLoading,
  };
};
